export enum BUTTON_VARIANT {
  PRIMARY = 'primary',
  OUTLINED = 'outlined',
}

export enum DashboardUserType {
  ADMIN = 'admin',
  SELLER = 'seller',
}

export function parseEnum<T extends { [s: string]: unknown }>(
  enumObj: T,
  value: string
): T[keyof T] | null {
  const enumValues = Object.values(enumObj);
  return enumValues.includes(value as T[keyof T])
    ? (value as T[keyof T])
    : null;
}
